import { featureToggleSelectors } from '@makemydeal/dr-shared-store';
import { logNewRelicPageAction } from '@makemydeal/dr-activities-common';
import { PUSH_TO_DMS_WS_EVENT } from '../../actionTypes/pushToDmsActionTypes';
import type { TopicHandler } from './types';

export const handleMvPushToDms: TopicHandler = (state, event) => {
    if (!featureToggleSelectors.enableOptionalPbcUi(state)) return null;
    if (event.message?.includes('subscribe')) return null;
    if (event.data?._type !== 'pushToDmsEvent') {
        logNewRelicPageAction('MV:CDMS', {
            type: 'WsEventDropped',
            reason: 'typeMismatch',
            actualType: event.data?._type
        });
        return null;
    }
    /* istanbul ignore next -- event.data is guaranteed non-null past the _type guard above */
    const dmsDealId = event.data?.payload?.dms_deal_id;
    logNewRelicPageAction('MV:CDMS', {
        type: 'WsDispatched',
        status: 'success',
        dmsDealId
    });
    return { type: PUSH_TO_DMS_WS_EVENT, payload: event };
};
